module.exports = __webpack_public_path__ + "img/chongci_ps_08.21c81a96.jpg";